import { useAppSelector } from './reactRedux';

const useAuthSelector = () => useAppSelector((state) => state.user);

export default useAuthSelector;
